/*
 * @Date: 2024-09-13 16:43:42
 * @LastEditors: p彭 9878922+p-pengrulin@user.noreply.gitee.com
 * @LastEditTime: 2024-10-08 12:35:22
 */
/**
 * @description: 复制hooks
 */

let openWallet;
let retryArr = [];
export default () => {
  const setWallet = (fn) => {
    openWallet = fn;
  };

  /**
   * @description: 判断是否登录后打开登录弹框
   */
  const open = () => {
    return openWallet?.();
  };

  const setRetry = (config) => {
    retryArr.push(config);
  };

  const handleRetry = () => {
    if (retryArr.length) {
      setTimeout(() => {
        location.reload();
        retryArr = [];
      }, 500);
    }
  };
  return {
    setWallet,
    open,
    setRetry,
    handleRetry,
  };
};
